import { http } from '../axios';
import { shopPrefix } from '../../config';
import { GroupingState } from '../../store/grouping/state';

const url = `${shopPrefix}/v1/selectionlists/:listId/bundles`;

export function fetchSelectionListGroupedItems({ listId }: { listId: string }) {
    return http
        .get<GroupingState[]>(url, {
            pathParams: { listId }
        })
        .then(response => response.data);
}
